<template>
  <div class="home">
    <HeaderMain></HeaderMain>
    <main>
      <div class="frontpage-top-banner">
        <span>Köp & Sälj på Gluo - <router-link :to="{ name: 'item-create' }">Just nu gratis annonsering!</router-link></span>
      </div>
      <div class="container">
        <div class="search">
          <form class="search-form" action="" @submit.prevent="querySubmit()">
            <input class="search-form-input" type="search" placeholder="Vad söker du idag?" ref="searchInput" :class="{ 'search-form-input-hash': q.charAt(0) === '#' }" v-model="q" @keyup.enter="submit">
            <button class="button-reset search-form-clear-button" type="button" v-show="q">
              <i class="fas fa-times" @click="queryClear()"></i>
            </button>
            <button class="button-reset search-form-submit-button" type="submit">
              <i class="fas fa-search"></i>
            </button>
          </form>
          <span class="search-hash-error" v-if="hashError">Ogiltigt nummer eller så har annonsen tagits bort.</span>
        </div>
        <div class="search-filter">
          <button class="button-reset search-filter-button" type="button" @click="showFilterOptions = !showFilterOptions">
            Sökfilter<i class="fas" :class="{ 'fa-angle-up': showFilterOptions, 'fa-angle-down': !showFilterOptions }"></i>
          </button>
          <transition name="transition-fade">
            <div class="search-filter-options-wrapper" v-show="showFilterOptions">
              <button class="button-reset search-filter-reset-button" type="button" :disabled="!filter.region.toString() && !filter.category.toString()" @click="filterReset()">
                <i class="fas fa-times-circle"></i>Rensa filter
              </button>
              <div class="search-filter-options">
                <div class="search-filter-option">
                  <div class="select-wrapper">
                    <select class="search-filter-select" v-model="filter.region" @change="regionChange()">
                      <option value="">Hela Sverige</option>
                      <option v-for="(region, index) in regions" :key="index" :value="region.id.toString()">{{ region.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="search-filter-option">
                  <div class="select-wrapper">
                    <select class="search-filter-select" v-model="filter.area" @change="routerPush()">
                      <option value="">Alla områden</option>
                      <option v-for="(area, index) in areas[filter.region - 1]" :key="index" :value="area.id">{{ area.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="search-filter-option">
                  <div class="select-wrapper">
                    <select class="search-filter-select" v-model="filter.category" @change="categoryChange()">
                      <option value="">Alla kategorier</option>
                      <option v-for="(category, index) in categories" :key="index" :value="category.id.toString()">{{ category.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="search-filter-option">
                  <div class="select-wrapper">
                    <select class="search-filter-select" v-model="filter.subcategory" @change="routerPush()">
                      <option value="">Alla underkategorier</option>
                      <option v-for="(subcategory, index) in subcategories[filter.category - 1]" :key="index" :value="subcategory.id.toString()">{{ subcategory.name }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div class="container">
        <div class="results-header" v-if="items.length">
          <span class="results-header-count">Visar <strong>{{ items.length }}</strong> av <strong>{{ totalRows }}</strong></span>
          <div class="select-wrapper">
            <select class="search-filter-select-sort" v-model="filter.sort" @change="routerPush()">
              <option value="">Senaste</option>
              <option value="rdate">Äldst</option>
              <option value="price">Billigast</option>
              <option value="rprice">Dyrast</option>
            </select>
          </div>
        </div>
        <div class="results-header" v-else>&nbsp;</div>
      </div>
        <div class="container container-padding items-container">
          <transition name="transition-fade">
            <ul class="list-reset items-list items-list-placeholder" v-if="resultsLoading">
              <li class="items-list-item items-list-item-placeholder">
                <div class="items-list-item-link">
                  <div class="items-list-item-image-box items-list-item-image-box-placeholder"></div>
                  <div class="items-list-item-meta">
                    <div class="items-list-item-header">
                      <span class="items-list-item-header-area items-list-item-header-area-placeholder">&nbsp;</span>
                      <span class="items-list-item-header-date items-list-item-header-date-placeholder">&nbsp;</span>
                    </div>
                    <div class="items-list-item-details">
                      <span class="items-list-item-details-title items-list-item-details-title-placeholder">&nbsp;</span>
                      <span class="items-list-item-details-price items-list-item-details-price-placeholder">&nbsp;</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <ul class="list-reset items-list" v-else-if="items.length" key="tr">
              <transition-group name="transition-fade">
                <li class="items-list-item" v-for="item in items" :key="item.id">
                  <a :href="'annons/' + item.slug + '/' + item.id" class="items-list-item-link" @click.prevent="linkClick(item)">
                    <div class="items-list-item-image-box">
                      <img class="items-list-item-image" alt="" v-if="Object.keys(item.thumbnail).length" :src="item.thumbnail.url">
                      <div class="items-list-item-image-no-image" v-else></div>
                    </div>
                    <div class="items-list-item-meta">
                      <div class="items-list-item-header">
                        <span class="items-list-item-header-category">{{ item.category.name }}&nbsp;&bull;&nbsp;</span>
                        <span class="items-list-item-header-location" v-html="item.area ? item.area.name : 'Gotland'"></span>
                        <span class="items-list-item-header-date">
                          <time :datetime="item.created_at_local">{{ item.created_at_formatted }}</time>
                        </span>
                      </div>
                      <div class="items-list-item-details">
                        <h2 class="items-list-item-details-title">{{ item.title }}</h2>
                        <span class="items-list-item-details-price">{{ item.price_formatted }} kr</span>
                      </div>
                    </div>
                  </a>
                </li>
              </transition-group>
            </ul>
            <div class="centered" v-else-if="!totalRows && !responseError" key="nf">
              <strong>Inga annonser hittades</strong>
              <p>Din sökning gav inga träffar.</p>
            </div>
            <div class="centered" v-else key="re">
              <strong>Oj, nu blev det något fel!</strong>
              <p>Försök igen om en stund så borde det ha löst sig.</p>
            </div>
          </transition>
        </div>
      <div class="items-load-more" v-if="items.length !== totalRows && !responseError">
        <button class="button-reset items-load-more-button" type="button" :class="{ 'items-load-more-button-disabled': loadMoreDisabled }" :disabled="loadMoreDisabled" @click="loadMore()">
          <i class="fas fa-angle-down"></i><i v-if="loadMoreLoading">Hämtar...</i><span v-else>Visa mer</span>
        </button>
      </div>
    </main>
    <FooterMain></FooterMain>
  </div>
</template>

<script>
import axios from 'axios'
import HeaderMain from '@/components/HeaderMain.vue'
import FooterMain from '@/components/FooterMain.vue'
import categories from '@/data/categories.json'
import subcategories from '@/data/subcategories.json'
import regions from '@/data/regions.json'
import areas from '@/data/areas.json'

export default {
  name: 'Home',
  components: {
    HeaderMain,
    FooterMain
  },
  data () {
    return {
      q: '',
      filter: {
        region: '',
        area: '',
        category: '',
        subcategory: '',
        sort: ''
      },
      page: 1,
      resultsPerPage: 15,
      totalRows: 0,
      showFilterOptions: false,
      resultsLoading: true,
      loadMoreLoading: false,
      loadMoreDisabled: false,
      responseError: false,
      hashError: false,
      categories: categories,
      subcategories: subcategories,
      regions: regions,
      areas: areas,
      items: []
    }
  },
  methods: {
    filterReset () {
      this.filter.region = ''
      this.filter.area = ''
      this.filter.category = ''
      this.filter.subcategory = ''

      this.routerPush()
    },
    queryClear () {
      this.q = ''

      if (this.hashError) {
        this.hashError = false
      } else {
        this.routerPush()
      }
    },
    regionChange () {
      this.filter.area = ''
      this.routerPush()
    },
    categoryChange () {
      this.filter.subcategory = ''
      this.routerPush()
    },
    linkClick (item) {
      sessionStorage.setItem('s_page', this.page)
      sessionStorage.setItem('s_y', window.scrollY)
      sessionStorage.setItem('s_query', this.$route.fullPath)

      this.$router.push({
        name: 'item-view',
        params: {
          slug: item.slug,
          id: item.id
        }
      })
    },
    querySubmit () {
      if (this.q.charAt(0) === '#') {
        let itemId = this.q.slice(1)

        axios.get(process.env.VUE_APP_API_ENDPOINT + '/search/' + itemId)
        .then(response => {
          if (sessionStorage.getItem('s_page')) { sessionStorage.removeItem('s_page') }
          if (sessionStorage.getItem('s_y')) { sessionStorage.removeItem('s_y') }
          if (sessionStorage.getItem('s_query')) { sessionStorage.removeItem('s_query') }

          this.$router.push({
            name: 'item-view',
            params: {
              slug: response.data.slug,
              id: response.data.id
            }
          })
        })
        .catch(() => {
          this.hashError = true
        })
      }
      else {
        if (this.hashError) {
          this.hashError = false
        }

        this.routerPush()
      }
    },
    search () {
      this.$refs.searchInput.blur()
      this.resultsLoading = true

      axios.get(process.env.VUE_APP_API_ENDPOINT + '/search', {
        params: {
          q: this.q,
          region: this.filter.region,
          area: this.filter.area,
          category: this.filter.category,
          subcategory: this.filter.subcategory,
          sort: this.filter.sort,
          limit: this.resultsPerPage,
          page: this.page
        }
      })
      .then(response => {
        this.items = response.data.items
        this.totalRows = response.data.data.total_rows
        this.resultsLoading = false

        if (sessionStorage.getItem('s_y')) {
          const y = sessionStorage.getItem('s_y')
          this.$nextTick(() => {
            window.scrollTo(0, y)
          })
        }
      })
      .catch(() => {
        this.responseError = true
        this.resultsLoading = false
      })
    },
    loadMore () {
      this.loadMoreLoading = true

      axios.get(process.env.VUE_APP_API_ENDPOINT + '/search', {
        params: {
          q: this.q,
          region: this.filter.region,
          area: this.filter.area,
          category: this.filter.category,
          subcategory: this.filter.subcategory,
          sort: this.filter.sort,
          limit: this.resultsPerPage,
          offset: this.items.length
        }
      })
      .then(response => {
        this.items = this.items.concat(response.data.items)
        this.totalRows = response.data.data.total_rows

        this.page++
        this.loadMoreLoading = false
      })
      .catch(() => {
        this.loadMoreLoading = false
      })
    },
    setParams () {
      this.q = this.$route.query.q ? this.$route.query.q : ''
      this.filter.region = this.$route.query.region ? this.$route.query.region : ''
      this.filter.area = this.$route.query.area ? this.$route.query.area : ''
      this.filter.category = this.$route.query.category ? this.$route.query.category : ''
      this.filter.subcategory = this.$route.query.subcategory ? this.$route.query.subcategory : ''
      this.filter.sort = this.$route.query.sort ? this.$route.query.sort : ''

      if (sessionStorage.getItem('s_page')) {
        this.page = sessionStorage.getItem('s_page')
      } else {
        this.page = 1
      }
    },
    routerPush () {
      let query = {}

      if (this.q.length) {
        this.$set(query, 'q', this.q)
      }
      if (this.filter.region.toString().length) {
        this.$set(query, 'region', this.filter.region)
      }
      if (this.filter.area.toString().length) {
        this.$set(query, 'area', this.filter.area)
      }
      if (this.filter.category.toString().length) {
        this.$set(query, 'category', this.filter.category)
      }
      if (this.filter.subcategory.toString().length) {
        this.$set(query, 'subcategory', this.filter.subcategory)
      }
      if (this.filter.sort.length) {
        this.$set(query, 'sort', this.filter.sort)
      }

      this.$router.push({ query: query }).catch(
        // eslint-disable-next-line
        (e) => {}
      )
    }
  },
  watch: {
    '$route.query' () {
      if (sessionStorage.getItem('s_page')) { sessionStorage.removeItem('s_page') }
      if (sessionStorage.getItem('s_y')) { sessionStorage.removeItem('s_y') }
      if (sessionStorage.getItem('s_query')) { sessionStorage.removeItem('s_query') }

      this.setParams()
      this.search()
    }
  },
  mounted () {
    document.title = 'Gluo Köp & Sälj - Enkelt och snabbt utan registrering!'

    this.setParams()
    this.search()
  },
  beforeRouteEnter (to, from, next) {
    if (from.name !== 'item-view') {
      if (sessionStorage.getItem('s_page')) { sessionStorage.removeItem('s_page') }
      if (sessionStorage.getItem('s_y')) { sessionStorage.removeItem('s_y') }
      if (sessionStorage.getItem('s_query')) { sessionStorage.removeItem('s_query') }
    }

    next()
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/modules/_breakpoints.scss';
@import '@/assets/scss/modules/_variables.scss';

.centered {
  width: 100%;
  height: 100%;
  padding-top: 32px;
  text-align: center;
  line-height: 3;
  position: absolute;
}

.frontpage-top-banner {
  background-color: #fff;
  border-bottom: 1px solid map-get($colors, brown-lighter);
  color: map-get($colors, green-dark);
  padding: 16px 16px;
  text-align: center;

  @include breakpoint-up($md) {
    font-size: 1.4rem;
  }
}

.search {
  margin-top: 32px;
  margin-bottom: 32px;

  @include breakpoint-up($md) {
    margin-top: 48px;
  }
}

.search-hash-error {
  color: map-get($colors, red-base);
  margin-top: 8px;
  text-align: center;
  display: block;
}

.search-form {
  max-width: 340px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 16px;
  padding-right: 16px;
  position: relative;
}

.search-form-input {
  border-radius: 4px;
  font-size: 1.6rem;
  width: 100%;
  padding: 10px 62px 10px 14px;
  line-height: normal;
}

.search-form-input:focus {
  border-color: map-get($colors, yellow-base);
  box-shadow: 0 0 0 2px map-get($colors, yellow-lighter);
}

.search-form-input-hash {
  color: map-get($colors, gray-medium);
  font-weight: 700;
}

.search-form-clear-button {
  color: map-get($colors, gray-medium);
  font-size: 14px;
  width: 24px;
  height: 100%;
  position: absolute;
  right: 56px;
}

.search-form-clear-button .fas {
  cursor: pointer;
}

.search-form-submit-button {
  color: map-get($colors, gray-base);
  cursor: pointer;
  font-size: 16px;
  height: 100%;
  padding-left: 8px;
  padding-right: 16px;
  position: absolute;
  right: 16px;
}

.search-form-submit-button:hover {
  color: map-get($colors, yellow-base);
}

.search-filter {
  background-color: #fff;
  border-top: 1px solid map-get($colors, gray-lighter);
  border-bottom: 1px solid map-get($colors, gray-lighter);
  margin-bottom: 12px;
  padding-left: 12px;
  padding-right: 12px;
  text-align: right;

  @include breakpoint-up($md) {
    background: none;
    border-top: 0;
    border-bottom: 0;
    margin-bottom: 0;
    padding-left: 0;
    padding-right: 0;
  }
}

.search-filter-button {
  color: map-get($colors, gray-medium);
  cursor: pointer;
  font-weight: 700;
  width: 100%;
  padding: 16px 4px;
  text-align: center;

  @include breakpoint-up($md) {
    display: none;
  }
}

.search-filter-button:hover {
  color: map-get($colors, gray-base);
}

.search-filter-button .fas {
  color: map-get($colors, gray-medium);
  margin-left: 6px;
}

.search-filter-options-wrapper {
  @include breakpoint-up($md) {
    display: block !important;
  }
}

.search-filter-options {
  padding-bottom: 8px;

  @include breakpoint-up($md) {
    margin-left: -4px;
    margin-right: -4px;
    padding-bottom: 0;
  }
}

.search-filter-option {
  width: 50%;
  margin-bottom: 8px;
  padding-left: 4px;
  padding-right: 4px;
  display: inline-block;

  @include breakpoint-up($md) {
    width: 25%;
  }
}

.search-filter-option .select-wrapper,
.search-filter-select {
  width: 100%;
}

.search-filter-reset-button {
  color: map-get($colors, gray-medium);
  cursor: pointer;
  margin-top: 16px;
  margin-bottom: 16px;

  @include breakpoint-up($md) {
    font-size: 1.3rem;
    margin-top: 0;
    margin-bottom: 12px;
    display: inline !important;
  }
}

.search-filter-reset-button:hover {
  color: map-get($colors, red-base);
}

.search-filter-reset-button .fas {
  margin-right: 6px;
}

.results-header {
  background-color: #fff;
  color: map-get($colors, gray-medium);
  border-top: 1px solid map-get($colors, brown-lighter);
  padding: 10px 16px;
  position: relative;
  top: 1px;
  display: flex;
  align-items: center;

  @include breakpoint-up($md) {
    border-left: 1px solid map-get($colors, brown-lighter);
    border-right: 1px solid map-get($colors, brown-lighter);
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
}

.results-header .results-header-count {
  @include breakpoint-up($md) {
    font-size: 1.3rem;
  }
}

.results-header .select-wrapper {
  line-height: 1.15;
  margin-left: auto;
}

.results-header .select-wrapper::after {
  top: 1px;
  right: 0;
}

.results-header .search-filter-select-sort {
  border: 0;
  box-shadow: none;
  color: map-get($colors, gray-medium);
  padding: 0 14px 0 0;
}

.results-header .search-filter-select-sort:hover {
  color: map-get($colors, gray-base);
}

.results-header .search-filter-select-sort option {
  color: map-get($colors, gray-dark);
}

.items-container {
  background-color: #fff;
  border-bottom: 1px solid map-get($colors, brown-lighter);
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  min-height: 161px;
  position: relative;

  @include breakpoint-up($md) {
    border-left: 1px solid map-get($colors, brown-lighter);
    border-right: 1px solid map-get($colors, brown-lighter);
  }
}

.items-list {
  width: 100%;
  padding-bottom: 16px;
}

.items-list-item {
  margin-left: -16px;
  margin-right: -16px;

  @include breakpoint-up($md) {
    margin-left: 0;
    margin-right: 0;
  }
}

.items-list-item:not(:first-child) {
  border-top: 1px solid map-get($colors, brown-lighter);
}

.items-list-item-link {
  padding: 16px;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
  display: flex;

  @include breakpoint-up($md) {
    padding-top: 20px;
    padding-bottom: 20px;
  }
}

.items-list-item-link:hover {
  background-color: map-get($colors, gray-whiter);
}

.items-list-item-link:active .items-list-item-image {
  opacity: 0.8;
}

.items-list-item-image-box {
  background-color: map-get($colors, gray-whiter);
  border-radius: 3px;
  width: 110px;
  height: 83px;
  display: flex;
  justify-content: center;

  @include breakpoint-up($md) {
    width: 133px;
    height: 100px;
  }
}

.items-list-item-image {
  border-radius: 3px;
  max-width: 100%;
  height: 100%;
}

.items-list-item-image-no-image {
  background: url('~@/assets/svg/gluo-no-image.svg') no-repeat center;
  background-size: 78px;
  width: 78px;

  @include breakpoint-up($md) {
    background-size: 100px;
    width: 100px;
  }
}

.items-list-item-meta {
  width: 100%;
  margin-left: 16px;
  position: relative;
  flex: 1;
}

.items-list-item-header {
  color: map-get($colors, gray-base);
  font-size: 1.3rem;
  width: 100%;
  display: flex;
}

.items-list-item-header-category {
  display: none;

  @include breakpoint-up($md) {
    display: inline;
  }
}

.items-list-item-header-location {
  padding-right: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  flex: 1;
}

.items-list-item-header-date {
  margin-left: auto;
}

.items-list-item-details {
  margin-top: 8px;

  @include breakpoint-up($md) {
    display: flex;
  }
}

.items-list-item-details-title {
  font-size: 1.6rem;
  font-weight: 700;
  max-height: 3.8rem;
  overflow: hidden;

  @include breakpoint-up($md) {
    font-size: 1.8rem;
    max-height: 4.6rem;
    flex: 1;
  }
}

.items-list-item-details-price {
  color: map-get($colors, green-base);
  font-size: 1.6rem;
  font-weight: 700;
  position: absolute;
  bottom: 0;

  @include breakpoint-up($md) {
    font-size: 1.8rem;
    width: 180px;
    line-height: 1.4;
    text-align: right;
    position: static;
  }
}

.items-list-placeholder {
  position: absolute;
}

.items-list-item-image-box-placeholder,
.items-list-item-header-area-placeholder,
.items-list-item-header-date-placeholder,
.items-list-item-details-title-placeholder,
.items-list-item-details-price-placeholder {
  background-color: map-get($colors, gray-whiter);
  border-radius: 3px;
}

.items-list-item-image-box-placeholder {
  min-width: 110px;
  min-height: 83px;
  display: block;

  @include breakpoint-up($md) {
    min-width: 140px;
    min-height: 105px;
  }
}

.items-list-item-header-area-placeholder {
  width: 30%;
}

.items-list-item-header-date-placeholder {
  width: 100px;
}

.items-list-item-details-title-placeholder {
  width: 100%;
  margin-top: 6px;
  margin-right: 80px;
  padding: 4px;
  display: block;
}

.items-list-item-details-price-placeholder {
  width: 80px;
  margin-top: 6px;
  padding: 4px;
}

.items-load-more {
  text-align: center;
}

.items-load-more-button {
  background-color: #fff;
  border: 1px solid map-get($colors, gray-lighter);
  border-top: none;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  color: map-get($colors, gray-medium);
  font-weight: 700;
  padding: 12px 24px;
  position: relative;
  top: -1px;

  @include breakpoint-up($md) {
    font-size: 1.3rem;
  }
}

.items-load-more-button:hover {
  color: map-get($colors, green-dark);
  cursor: pointer;
}

.items-load-more-button .fas {
  margin-right: 8px;
}

.items-load-more-button-disabled,
.items-load-more-button-disabled:hover {
  color: map-get($colors, gray-lighter);
}
</style>
